import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quilleditor";
import DatePicker from "../../../Components/DatePicker/datePicker";
import SectionToolbar from "../../../Components/GlobalSectionToolbar/SectionToolbar";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";

function Achievements(props) {
  const {
    resumeFields,
    sectionId,
    sectionTitleUpdate,
    handleEditorChange,
    resumeHandler,
    resumeTitleHandler,
    resumeUpdate,
    styles,
    settings,
    dateHandler,
    handleSliderChange,
  } = props;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );

  const customizationData = useSelector(
    (state) => state.editorData.customization
  );

  const [showSettings, setShowSettings] = useState(false);
  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  //UseForm

  const { showHideElements } = ResumeSubUseForm(props.sectionId);

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const handleDatePicker = () => {
    setShowDatePicker(true);
  };
  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <div
            className={
              settings && settings.showIcon
                ? "d-flex achievements-title title-section "
                : "achievements-title title-section"
            }
            style={{
              backgroundColor:
                styles &&
                styles.isTitleBackgroundColor &&
                styles.isTitleBackgroundColor
                  ? styles.sectionTitleColor
                  : "unset",
            }}
          >
            {settings && settings.showIcon && (
              <span
                style={{
                  marginTop: "auto",
                  color: styles.secondaryColor,
                }}
              >
                <i
                  className="fa fa-star pr-2"
                  aria-hidden="true"
                  style={{
                    fontSize: styles.titleFontSize,
                  }}
                ></i>
              </span>
            )}
            <ContentEditable
              sectionId={sectionId}
              id={`achievements-title`}
              name="customTitle"
              index="0"
              tagType="h5"
              className="section-title"
              value={
                resumeFields.customTitle
                  ? t(`customTitle`, {
                      customTitle: resumeFields.customTitle,
                    })
                  : t(`achievements.defaultTitle`)
              }
              style={{
                color: styles.primaryColor,
                fontFamily: styles.titleFont,
                fontSize: styles.titleFontSize,
                fontWeight: styles.bold,
              }}
              placeholder="Title"
              onChange={resumeTitleHandler}
              onBlur={resumeUpdate}
            />
          </div>
          <div className="section-item-wrapper achievements-item-wrapper">
            {resumeFields &&
              resumeFields.data &&
              resumeFields.data.map((response, index, row) => (
                <div
                  className={`achievements-item resume-item
                            ${
                              props.newSectionFocus == props.sectionId &&
                              props.currentStateFocus == "item" &&
                              props.newItemFocus &&
                              props.newItemFocus == index.toString()
                                ? "sectionFocusStyle"
                                : ""
                            }
                          `}
                  id={`achievements-${index}`}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    innerSectionClick(e, index);
                  }}
                >
                  {showQuillToolbar &&
                    props.newSectionFocus == props.sectionId &&
                    props.currentStateFocus == "item" &&
                    props.newItemFocus &&
                    props.newItemFocus == index.toString() && (
                      <SectionItemToolbar
                        index={index}
                        indexString={index.toString()}
                        handleDelete={props.handleItemDelete}
                        addAdditionalField={props.addAdditionalField}
                        sectionItemMoveUp={props.sectionItemMoveUp}
                        sectionItemMoveDown={props.sectionItemMoveDown}
                        row={row}
                        sectionId={props.sectionId}
                        startFrom={response.startFrom}
                        endUntil={response.endUntil}
                        resumeUpdate={resumeUpdate}
                        dateHandler={dateHandler}
                        showDatePicker={showDatePicker}
                        response={response}
                        changeSettings={props.changeSettings}
                        handleSliderChange={handleSliderChange}
                      />
                    )}
                  {response &&
                    response.showFields &&
                    response.showFields.name && (
                      <ContentEditable
                        sectionId={sectionId}
                        name="name"
                        index={index}
                        tagType="h5"
                        className=""
                        value={response.name}
                        placeholder="Award"
                        onChange={resumeHandler}
                        onBlur={resumeUpdate}
                        style={{
                          color: styles.primaryColor,
                          fontFamily: styles.bodyFont,
                          fontSize: styles.bodyFontSize,
                          fontWeight: styles.bold,
                        }}
                      />
                    )}
                  {response &&
                    response.showFields &&
                    response.showFields.description && (
                      <div className="achievements-description resume-description">
                        <Quilleditor
                          type="visual"
                          showQuillToolbar={showQuillToolbar}
                          changesetShowQuillToolbar={changesetShowQuillToolbar}
                          theme="snow"
                          className={``}
                          inivalue={response?.description?.replace(
                            /\n|\r/g,
                            ""
                          )}
                          current={index}
                          setvalue={handleEditorChange}
                          onBlur={resumeUpdate}
                          styles={styles}
                          sectionId={props.sectionId}
                          placeholder="A varied education on your resume sums up the value that your learnings and background will bring to job"
                        />
                      </div>
                    )}
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
}

export default Achievements;
